/**
 * View helpers for crew display
 * Provides consistent name display across all modules
 */

/**
 * Get display name for a crew member
 * Handles various field name variations for legacy compatibility
 * 
 * @param {Object} m - Crew member object
 * @returns {string} Display name or 'Unknown' if no name found
 */
export const displayName = (m) => {
  if (!m) return 'Unknown';
  
  // Try various field names in order of preference
  const name = m?.name || m?.full_name || m?.fullName || m?.displayName;
  
  // If we have a name, return it trimmed
  if (name && typeof name === 'string') {
    return name.trim();
  }
  
  // Try to construct from first/last names if available
  if (m?.firstName || m?.lastName) {
    return `${m.firstName || ''} ${m.lastName || ''}`.trim();
  }
  
  // Last resort - return Unknown
  return 'Unknown';
};

/**
 * Get display string for crew member with role
 * Used in dropdowns and selectors
 * 
 * @param {Object} m - Crew member object
 * @returns {string} Name with role suffix
 */
export const displayNameWithRole = (m) => {
  const name = displayName(m);
  const role = m?.role || m?.position || m?.positionTitle || 'Crew';
  
  if (name === 'Unknown') {
    return role;
  }
  
  return `${name} - ${role}`;
};